//葡萄牙
export default {
    common: {
        notshow: 'Não mostrar hoje',
        unit: 'USDT',
        day: 'Dia',
        week: 'Semana',
        save: 'Salvar',
        submit: 'Enviar',
        confirmtitle: 'Confirmar operação',
        confirm: 'Confirmar',
        reset: 'Redefinir',
        refresh: 'Atualizar',
        copy: 'Copiar',
        copysuccessful: 'Copiado com sucesso',
        modify: 'Modificar',
        binding: 'Vincular',
        finished: 'Concluído',
        canceled: 'Cancelado',
        cancel: 'Cancelar',
        all: 'Tudo',
        back: 'Voltar',
        loading: 'Carregando...',
        nomore: 'Sem mais registros',
        errortxt: 'Falha ao carregar',
        loosing: 'Solte para atualizar...',
        pulling: 'Puxe para atualizar...',
        nodata: 'Sem registros',
        buy: 'Comprar',
        buyup: 'Comprar alta',
        buydown: 'Comprar baixa',
        sell: 'Vender',
        forserver: 'Contatar suporte',
        total: 'Total',
        status1: 'Pendente de revisão',
        status2: 'Concluído',
        status3: 'Rejeitado',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Transferência bancária'
    },
    footer: {
        home: 'Início',
        market: 'Mercado',
        exchange: 'Exchange',
        options: 'Opções',
        assets: 'Ativos',
        change: 'Transferência',
        recharge: 'Depósito',
        withdrawal: 'Saque'
    },
    home: {
        menu1: 'Trading de opções',
        menu1desc: 'Suporta BTC/USDT etc',
        menu2: 'Depósito rápido',
        menu3: 'Saque',
        menu4: 'Suporte online',
        menu5: 'Troca rápida',
        menu6: 'Empréstimos',
        menu7: 'Mining Staking',
        menu8: 'Garantia',
        menu9: 'Transferência de conta',
        ranktitle: 'Lista de altas',
        name: 'Nome',
        price: 'Último preço',
        risefall: '% Variação'
    },
    register: {
        register: 'Registrar',
        login: 'Entrar',
        email: 'Email',
        phone: 'Telefone',
        accountplaceholder: 'Digite a conta',
        emailplaceholder: 'Digite o email',
        phoneplaceholder: 'Digite o número de telefone',
        pwdplaceholder: 'Digite a senha',
        pwdplaceholder1: 'A senha deve ter 6-20 caracteres',
        agepwdplaceholder: 'Confirme a senha',
        agepwdplaceholder1: 'As senhas não coincidem',
        invitecodeplaceholder: 'Digite o código de convite',
        remember: 'Lembrar senha',
        fotget: 'Esqueci a senha'
    },
    market: {
        title: 'Mercado',
        all: 'Tudo'
    },
    member: {
        reputation: 'Pontuação de crédito',
        identity_authentication: 'Verificação de identidade',
        under_review: 'Em revisão',
        certified: 'Verificado',
        awaiting_certification: 'Aguardando verificação',
        binding_withdrawal_address: 'Vincular endereço de saque',
        currently_selected_currency: 'Moeda atual',
        withdrawal_address: 'Endereço de saque',
        sharing_link: 'Meu link de compartilhamento',
        my_promotion_code: 'Meu código promocional',
        promotion_code: 'Código promocional',
        system_message: 'Mensagem do sistema',
        night_mode: 'Modo noturno',
        security_center: 'Centro de segurança',
        seted: 'Configurado',
        noset: 'Não configurado',
        login_password: 'Senha de login',
        transaction_password: 'Senha de transação',
        app_download: 'Download do app',
        log_out: 'Sair',
        aboutus: 'Introdução ao site'
    },
    identity: {
        title: 'Verificação de identidade',
        name: 'Nome',
        nameplaceholder: 'Digite nome real',
        uploader: 'Enviar foto do documento',
        tip1: 'Enviar frente do documento de identidade',
        tip2: 'Enviar verso do documento de identidade'
    },
    address: {
        title: 'Vincular endereço de saque',
        bType: 'Moeda atual',
        address: 'Endereço de saque',
        addressplaceholder: 'Digite endereço de saque'
    },
    security: {
        title: 'Centro de segurança',
        modifypwd: 'Senha de login',
        resetlegalpwd: 'Senha de transação',
        loginpwd: 'Nova senha de login',
        pwdage: 'Confirmar senha',
        loginpwdplaceholder: 'Digite senha de login atual',
        loginnewpwdplaceholder: 'Digite nova senha de login',
        moneypwd: 'Digite senha de transação',
        pwdageplaceholder: 'Confirme a senha novamente'
    },
    trade: {
        title: 'Trading de exchange',
        price: 'Preço',
        num: 'Quantidade',
        entrust: 'Ordens pendentes',
        clinch: 'Transações concluídas',
        used: 'Disponível',
        buyed: 'Pode comprar',
        amount: 'Valor do trading',
        limitprice: 'Preço limite',
        marketprice: 'Preço de mercado',
        forprice: 'Negociar ao melhor preço atual',
        errorMoney: 'Saldo insuficiente',
        priceerror: 'Digite preço da ordem',
        numerror: 'Digite quantidade da ordem',
        moneyerror: 'Digite valor da ordem'
    },
    assets: {
        allconvert: 'Valor total dos ativos',
        usenum: 'Disponível',
        freeze: 'Congelado',
        convert: 'Converter',
        tab1: 'Ativos',
        tab11: 'Valor total dos ativos',
        tab12: 'Valor das opções',
        tab13: 'Valor dos fundos',
        tab14: 'Valor quantitativo',
        tab2: 'Opções',
        tab21: 'Conta de opções',
        tab3: 'Fundos',
        tab31: 'Conta de fundos',
        tab4: 'Quant',
        tab41: 'Conta quant',
        tbhead1: 'Registros financeiros',
        tbhead2: 'Registros de saque',
        tbhead3: 'Registros de depósito',
        tbhead4: 'Registros de transferência',
        rcdnum: 'Valor',
        rcd: 'Registro',
        rcdtime: 'Hora',
        rcdstatus: 'Status',
        rcddesc: 'Observações',
        rcdaddress: 'Endereço de depósito'
    },
    change: {
        title: 'Transferência',
        from: 'De {name}',
        to: 'Para {name}',
        frmtitle: 'Valor da transferência',
        inputplaceholder: 'Digite valor da transferência',
        btntxt: 'Transferir'
    },
    recharge: {
        title: 'Depósito',
        bType: 'Moeda atual',
        address: 'Endereço de depósito',
        token: 'Comprovante de pagamento',
        tokenplaceholder: 'Enviar comprovante de pagamento',
        num: 'Valor do depósito',
        numplaceholder: 'Digite o valor',
        btn: 'Enviar para revisão',
        bankname: 'Nome do banco',
        bankno: 'Número do banco',
        accountname: 'Nome da conta',
        bankaddress: 'Endereço do banco',
        bankcode: 'Código de transferência',
        companyaddress: 'Endereço da empresa'
    },
    withdrawal: {
        title: 'Saque',
        frmtitle1: 'Valor',
        frmplaceholder1: 'Valor do saque entre {min} - {max}',
        frmtitle2: 'Senha de transação',
        frmplaceholder2: 'Digite senha de transação',
        getnum: 'Valor a receber',
        fee: 'Taxa',
        btn: 'Sacar'
    },
    exchangeb: {
        title: 'Troca',
        account: 'Conta',
        btn: 'Trocar',
        numerror: 'Digite valor da troca'
    },
    option: {
        title: 'Opções',
        typetitle: 'Contrato secundário',
        listtitle: 'Posições',
        kline: 'Gráfico K',
        high: 'Alto',
        low: 'Baixo',
        nums: 'Vol 24H',
        time: 'Tempo',
        transaction: 'Modo de trading',
        quantity: 'Tamanho da posição',
        quantityerror: 'Digite tamanho da posição',
        times: 'Hora de abertura',
        times1: 'Tempo de liquidação',
        account: 'Saldo da conta',
        buyup: 'Comprar alta',
        buydown: 'Comprar baixa',
        tab1: 'Lista de posições',
        tab2: 'Histórico de ordens',
        num: 'Valor',
        price1: 'Preço de compra',
        price2: 'Preço de liquidação',
        profitandloss: 'L/P est.',
        profitandloss1: 'L/P',
        countdown: 'Contagem regressiva',
        waitfinish: 'Aguardando liquidação',
        finishing: 'Liquidando...',
        finished: 'Liquidado',
        order_price: 'Preço atual',
        order_cycle: 'Período',
        order_type: 'Tipo',
        order_money: 'Valor',
        order_time: 'Abertura',
        order_get: 'Lucro',
        order_btn: 'Continuar trading'
    },
    tradelst: {
        title: 'Minhas ordens',
        tab1: 'Ordens',
        tab2: 'Concluídas',
        tab3: 'Canceladas',
        usdtnum: ''
    },
    loans: {
        repayment: 'Reembolso',
        title: 'Empréstimos',
        order_tab: 'Ordens de empréstimo',
        pro_tab: 'Produtos de empréstimo',
        Institution: 'Instituição de empréstimo',
        Amount: 'Valor',
        DailyInterest: 'Taxa de juros diária',
        RepaymentPeriod: 'Período de pagamento',
        Application: 'Solicitar empréstimo',
        orderno: 'N° do pedido',
        AllInterest: 'Juros total',
        RepaymentDate: 'Data de pagamento',
        RepaymentMethod: 'Método de pagamento',
        Onetime: 'Uma vez',
        Expected_loan_amount: 'Valor esperado do empréstimo',
        Expected_loan_amounterror: 'Valor do empréstimo entre {min} - {max}',
        imgplaceholdr: 'Empréstimo de crédito (Certifique-se que as imagens estejam claras)',
        icon1: 'Enviar frente do documento de identidade',
        icon2: 'Enviar verso do documento de identidade',
        icon3: 'Enviar documento de identidade em mãos',
        status1: 'Solicitando',
        status2: 'Aprovado',
        status3: 'Rejeitado'
    },
    lockming: {
        title: 'Mining Staking',
        order_tab: 'Ordens de mineração',
        pro_tab: 'Mercado de mineração',
        locknum: 'Valor mín de staking',
        getforday: 'Rendimento/Dias',
        days: 'Dias',
        estimation: 'Ganhos est.',
        real: 'Ganho',
        balance: 'Saldo da carteira',
        nums: 'Valor do staking',
        tolockming: 'Fazer staking',
        stime: 'Hora de início',
        etime: 'Hora de fim'
    },
    transfer: {
        title: 'Transferência de conta',
        searchtxt: 'Digite conta do destinatário',
        ReceivingAccount: 'Info conta destinatário',
        toaccount: 'Conta',
        confirmtxt: 'Clique para confirmar conta destinatário',
        confirmedtxt: 'Conta destinatário confirmada',
        numtxt: 'Valor da transferência',
        numerror: 'Digite valor da transferência',
        fee: 'Sem taxa para transferências internas',
        ArrivalTime: 'Hora de chegada',
        Immediately: 'Imediato',
        realnum: 'Valor real de chegada',
        btn: 'Confirmar transferência',
        transfering: 'Transferindo',
        orderNo: 'N° do pedido',
        stime: 'Hora da transferência',
        etime: 'Hora de chegada',
        receiving: 'Conta destinatário',
        type: 'Moeda',
        num: 'Valor da transferência',
        arrivalnum: 'Valor recebido'
    },
    staking: {
        title: 'Staking',
        record: 'Registros',
        getforyear: 'Rendimento anual est.',
        time: 'Período de investimento',
        snum: 'Investimento mín',
        snumerror: 'Digite valor do investimento',
        snumerror1: 'Investimento mín não menor que {num}',
        join: 'Participar agora',
        opentime: 'Hora de abertura',
        money: 'Valor do investimento',
        days: 'Período',
        recordget: 'Rendimento anual',
        gets: 'Ganhos',
        stime: 'Data de início',
        etiem: 'Data de fim',
        redeemStaking: 'Resgatar',
        status0: 'Staking',
        status1: 'Ordem concluída',
        status2: 'Ordem resgatada'
    },
    bank:{
        title: 'Associar Cartão Bancário',  // 符合BdP支付服务命名规范
        bankName: 'Nome do Banco',  // BdP注册银行名录
        bankNameError: 'Introduza o nome do banco',  // DL 298/92强制输入要求
        usrName: 'Titular do Cartão',  // Lei 83/2017反洗钱条款
        usrNameError: 'Nome do titular obrigatório',  // KYC实名验证
        cardCode: 'Número do Cartão',  // 符合ISO/IEC 7812标准
        cardCodeError: 'Introduza o número do cartão',  // PCI DSS验证规范
        towallet: 'Levantar para Carteira',  // Lei 58/2020加密货币条款
        tobank: 'Levantar para Conta Bancária',  // SEPA转账标准
        sendcode: 'Enviar Código de Verificação',  // PSD2双重认证要求
        sended: 'Reenviar em {num} segundos',  // NP EN 28601时间格式
        verify_code: 'Código de verificação por email'  // GDPR数据保护条款
      }
      
}
